import api from './api';

export const regionService = {
  async getRegions(params = {}) {
    const response = await api.get('/regions', { params });
    return response.data;
  },
  
  async getRegionById(id) {
    const response = await api.get(`/regions/${id}`);
    return response.data;
  },
  
  async createRegion(regionData) {
    const response = await api.post('/regions', regionData);
    return response.data;
  },
  
  async updateRegion(id, regionData) {
    const response = await api.put(`/regions/${id}`, regionData);
    return response.data;
  },
  
  async deleteRegion(id) {
    const response = await api.delete(`/regions/${id}`);
    return response.data;
  },
  
  async getRegionsByCategory(category) {
    const response = await api.get('/regions', { params: { category } });
    return response.data;
  },
  
  async getHotelsByRegion(regionId) {
    const response = await api.get(`/regions/${regionId}/hotels`);
    return response.data;
  }
};
